import styled from 'styled-components';

import type { ExtendedTheme } from '@theme/theme';

export const StyledResizableAside = styled.aside`
  background-color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.background.paper};
  ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
  .navigation-tree {
    &__resizable {
      height: 100% !important;
      position: relative;
    }
    &__splitter {
      position: absolute;
      top: 0;
      right: 0;
      width: 6px;
      height: 100%;
      z-index: 100;
      background: transparent;
      cursor: col-resize;
    }
  }
`;
